import { render, staticRenderFns } from "./ProductListWithoutCarousel.vue?vue&type=template&id=4e6e5472"
import script from "./ProductListWithoutCarousel.vue?vue&type=script&lang=js"
export * from "./ProductListWithoutCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports